import {CSSProperties} from '../../../styleSheet';
import {BasePositionPxProps} from '../types';

export const buildPositionStyle = ({
  position,
  absolute,
  left,
  top,
  right,
  bottom,
  zIndex,
}: BasePositionPxProps = {}): CSSProperties => {
  return {
    ...(position !== undefined ? {position} : {}),
    ...(absolute === true
      ? {
          position: 'absolute',
          left: '0px',
          top: '0px',
          right: '0px',
          bottom: '0px',
        }
      : {}),
    ...(top !== undefined ? {top: `${top}px`} : {}),
    ...(left !== undefined ? {left: `${left}px`} : {}),
    ...(bottom !== undefined ? {bottom: `${bottom}px`} : {}),
    ...(right !== undefined ? {right: `${right}px`} : {}),
    ...(zIndex !== undefined ? {zIndex} : {}),
  };
};
